<template>
  <div class="course-wtxh">
    <!-- 筛选区 -->
    <div class="filter-section" v-if="pageType == 1">
      <div class="filter-content">
        <div class="filter-row">
          <span class="filter-label">领域：</span>
          <span
            class="filter-option"
            :class="{active: categorySelect === 0}"
            @click="switchOne(0)"
          >全部</span>
          <span
            class="filter-option"
            v-for="item in category"
            :key="item.id"
            :class="{active: Number(categorySelect.id) == item.id}"
            @click="switchOne(item)"
          >{{ item.name }}</span>
        </div>
        <div class="filter-divider"></div>
        <div class="filter-row">
          <span class="filter-label">专业：</span>
          <span
            class="filter-option"
            :class="{active: category_id === 0}"
            @click="categoryListBtn(0)"
          >全部</span>
          <span
            class="filter-option"
            v-for="subItem in categorySelect.child"
            :key="subItem.id"
            :class="{active: category_id == subItem.id}"
            @click="categoryListBtn(subItem.id)"
          >{{ subItem.name }}</span>
        </div>
        <div class="filter-divider"></div>
        <div class="filter-row filter-row-yyz">
          <span class="filter-label">是否支持元宇宙跨空间培训：</span>
          <a class="tip-link" href="https://npx.kskstudy.com/activity/detail?id=32" target="_blank" rel="noopener noreferrer">
            <img src="@/assets/tip_icon.png" alt="" />
          </a>
          <span class="filter-option" :class="{active: yyzIndex == '1'}" @click="changYyzValue('1')">是</span>
          <span class="filter-option" :class="{active: yyzIndex == '2'}" @click="changYyzValue('2')">否</span>
        </div>
      </div>
    </div>
    <div class="filter-section" v-if="pageType == 2">
      <div class="filter-content">
        <div class="filter-row">
          <span class="filter-label">等级：</span>
          <span
            class="filter-option"
            :class="{active: category_id == 0}"
            @click="getSubCategoryList(0)"
          >全部</span>
          <span
            class="filter-option"
            v-for="item in category"
            :key="item.id"
            :class="{active: category_id == item.id}"
            @click="getSubCategoryList(item.id)"
          >{{ item.name }}</span>
        </div>
      </div>
    </div>
    <!-- 课程列表 -->
    <div class="course-grid-wrap">
      <ul class="course-grid" v-if="list.data && list.data.length">
        <li
          class="course-card"
          v-for="(item, idx) in list.data"
          :key="item.id"
          :style="{'animation-delay': idx * 50 + 'ms'}"
          @animationend="onCardAnimated"
          @click="goDetail(item)"
        >
          <div class="card-cover">
            <img v-lazy="item.image" :key="item.image" />
          </div>
          <div class="card-title">{{ item.name }}</div>
          <p class="card-intro">{{ item.intro || '' }}</p>
          <!-- <div class="card-teacher">
            <img
              class="teacher-avatar"
              v-if="item.teacher_avatar"
              :src="item.teacher_avatar"
            />
            <img class="teacher-avatar" v-else src="@/assets/per_img.png" />
            <span class="teacher-name">主讲老师：{{ item.teacher_name || '—' }}</span>
          </div> -->
        </li>
      </ul>
      <div class="empty-tip" v-else-if="loaded">暂无相关课程</div>
      <pagination-wtxh
        v-if="num > 0"
        :num="num"
        :limit="limit"
        @getNew="getNew"
        :key="paginationKey"
      ></pagination-wtxh>
    </div>
  </div>
</template>

<script>
import PaginationWtxh from "@/components/pc/paginationWtxh.vue";

export default {
  name: "CourseSelectionWtxh",
  components: {
    PaginationWtxh,
  },
  data() {
    return {
      pageType: 0,
      category: [],
      categorySelect: {},
      category_id: 0,
      list: [],
      num: 0,
      limit: 8,
      nowPage: 1,
      yyzIndex: "1",
      siteInfo: "",
      loaded: false,
      websiteData: "",
    };
  },
  computed: {
    paginationKey() {
      return (this.categorySelect.id || 0) + "_" + this.category_id;
    },
  },
  mounted() {
    this.siteInfo = JSON.parse(localStorage.getItem("siteInfo"));
    if (this.$route.name == "SeriesLessons") {
      this.pageType = 2;
      this.getSubCategory();
    } else if (this.$route.name == "CourseSelection") {
      this.pageType = 1;
      this.getCategory();
    }
    this.websiteData = JSON.parse(localStorage.getItem("websiteState"));
  },
  methods: {
    getCategory() {
      this.$axios.post(`/v1/course/category`).then((res) => {
        this.category = res.data;
        let pid = this.$route.query.pid;
        let id = this.$route.query.id || 0;
        if (pid) {
          for (let i in res.data) {
            if (res.data[i].id == pid) {
              this.categorySelect = res.data[i];
            }
          }
        } else {
          this.categorySelect = 0;
        }
        this.nowPage = 1;
        this.categoryListBtn(id);
      });
    },
    getSubCategory() {
      this.$axios.post(`/v1/subject/category`).then((res) => {
        this.category = res.data;
        this.getSubCategoryList(0);
      });
    },
    getNew(nowPage) {
      this.nowPage = nowPage;
      if (this.pageType == 1) {
        this.getCategoryList();
      } else {
        this.getSubCategoryList(this.category_id, "fanye");
      }
    },
    categoryListBtn(id) {
      this.category_id = id;
      this.nowPage = 1;
      this.getNew(this.nowPage);
    },
    getCategoryList() {
      if (this.yyzIndex == 2) {
        this.list = [];
        this.num = 0;
        this.loaded = true;
        return;
      }
      let category_id = this.category_id;
      if (category_id == 0) {
        category_id = this.categorySelect.id;
      }
      this.$axios
        .post(`/v1/course/list`, {
          category_id,
          page: this.nowPage,
          pre_page: this.limit,
        })
        .then((res) => {
          this.list = res.data;
          this.num = res.data.total;
          this.loaded = true;
        });
    },
    changYyzValue(num) {
      this.yyzIndex = num;
      this.nowPage = 1;
      this.getCategoryList();
    },
    getSubCategoryList(id, type) {
      this.category_id = id;
      let page = 0;
      if (type == "fanye") {
        page = this.nowPage;
      } else {
        page = 1;
        this.nowPage = 1;
      }
      this.$axios
        .post(`/v1/subject/list`, {
          category_id: id,
          page,
          pre_page: this.limit,
        })
        .then((res) => {
          this.list = res;
          this.num = res.total;
          this.loaded = true;
        });
    },
    switchOne(item) {
      this.categorySelect = item;
      this.category_id = 0;
      this.nowPage = 1;
      this.categoryListBtn(0);
    },
    goDetail(item) {
      if (this.pageType == 1) {
        this.$router.push("/recordedInfo/" + item.id);
      } else {
        this.$router.push("/seriesLessonsInfo/" + item.id);
      }
    },
    onCardAnimated(e) {
      e.target.style.animation = 'none';
      e.target.style.opacity = '1';
    },
  },
  watch: {
    $route() {
      this.$router.go(0);
    },
  },
};
</script>

<style scoped lang="scss">
.course-wtxh {
  overflow: hidden;
  background-color: rgba(247, 251, 252, 1);
}
// 筛选区
.filter-section {
  width: 1200px;
  margin: 30px auto 0;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0px 6px 18px 0px rgba(230, 230, 230, 0.56);
  padding: 36px 40px;
  box-sizing: border-box;
}
.filter-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0;
}
.filter-row-yyz {
  .tip-link {
    display: inline-flex;
    align-items: center;
    margin-right: 24px;
    img {
      width: 18px;
      height: 18px;
    }
  }
}
.filter-label {
  font-size: 20px;
  font-family: PingFangSC-Regular, "PingFang SC", sans-serif;
  color: rgba(51, 51, 51, 1);
  line-height: 28px;
  white-space: nowrap;
  margin-right: 30px;
}
.filter-option {
  font-size: 20px;
  font-family: PingFangSC-Regular, "PingFang SC", sans-serif;
  color: rgba(51, 51, 51, 1);
  line-height: 28px;
  white-space: nowrap;
  margin-right: 50px;
  cursor: pointer;
  transition: color 0.2s;
  &:last-child {
    margin-right: 0;
  }
  &:hover {
    color: rgba(55, 108, 236, 1);
  }
  &.active {
    color: rgba(55, 108, 236, 1);
    font-family: PingFangSC-Semibold, "PingFang SC", sans-serif;
    font-weight: 600;
  }
}
.filter-divider {
  width: 100%;
  height: 1px;
  background-color: rgba(230, 230, 230, 0.6);
  margin: 30px 0;
}
// 课程列表
.course-grid-wrap {
  width: 1200px;
  margin: 0 auto;
  padding: 50px 0 71px;
}
.course-grid {
  display: flex;
  flex-wrap: wrap;
  column-gap: 26px;
  row-gap: 26px;
  align-content: flex-start;
}
.course-card {
  width: 280px;
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0px 3px 17px 0px rgba(200, 200, 200, 0.4);
  overflow: hidden;
  cursor: pointer;
  opacity: 0;
  animation: cardFadeIn 0.4s ease forwards;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 12px 28px rgba(0, 0, 0, 0.12);
  }
}
@keyframes cardFadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.card-cover {
  width: 280px;
  height: 162px;
  overflow: hidden;
  border-radius: 6px 6px 0 0;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.card-title {
  padding: 16px 20px 0;
  font-size: 18px;
  font-family: PingFangSC-Medium, "PingFang SC", sans-serif;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 25px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.card-intro {
  padding: 6px 20px 0;
  font-size: 14px;
  font-family: PingFangSC-Regular, "PingFang SC", sans-serif;
  color: rgba(153, 153, 153, 1);
  line-height: 20px;
  min-height: 60px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}
.card-teacher {
  display: flex;
  align-items: center;
  padding: 10px 20px 20px;
}
.teacher-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
}
.teacher-name {
  margin-left: 11px;
  font-size: 15px;
  font-family: PingFangSC-Regular, "PingFang SC", sans-serif;
  color: rgba(153, 153, 153, 1);
  line-height: 21px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.empty-tip {
  text-align: center;
  padding: 80px 0;
  font-size: 16px;
  color: #999;
}
</style>
